import { apiClient } from '@/api/api'
import type {
  BrandCategoriesResponse,
  BrandsResponse,
  PopularBrand,
  PopularBrandsResponse
} from '@/types/brands'

export interface GetBrandsPayload {
  searchText: string
  sorting: 'asc' | 'desc'
  filters?: string[]
}

export interface PopularBrandsQuery {
  page_num: number
  page_size: number
  audience?: string
}

export const getBrands = async ({ searchText, sorting, filters }: GetBrandsPayload) => {
  return apiClient.post<BrandsResponse>('/brand/brands', {
    search_text: searchText,
    sorting,
    filters: filters?.length ? filters : undefined
  })
}

export const getBrandsCategories = async () => {
  return apiClient.get<BrandCategoriesResponse>('/brand/brand-categories')
}

export const getPopularBrands = async (payload: PopularBrandsQuery) => {
  return apiClient.get<PopularBrandsResponse>('/brand/popular', {
    params: payload
  })
}

export const getBrandInfo = async (brandId: number) => {
  return apiClient.get(`/brand/brand/${brandId}`)
}

export const subscribeToBrandUpdates = async (brandId: number) => {
  return apiClient.get(`/brand/track-brand-updates/${brandId}`)
}

export type { PopularBrand } from '@/types/brands'
